(function () {
  'use strict';

  angular
      .module('tfc.Files',
      [
        'ngFileUpload',
        'ngSanitize'
      ])
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('fileBase', {
          parent : 'pageWithMenu',
          data:{
            requireTerms:true
          },
          resolve : {
            retailers : function (Retailer) {
              return Retailer.find();
            }
          }
        })
        .state('upload', {
          parent : 'fileBase',
          url : '/upload?tla&year&category',
          data : {
            auth : {
              privilege : 'retailerManageReports'
            },
            path:'upload',
            title:'Upload Report',
            requireTerms:true
          },
          views : {
            '@pageWithMenu' : {
              templateUrl: 'Files/Upload.tmpl.html',
              controller : function ($state, $scope) {
                $scope.onUpload = function () {
                  $state.reload();
                };
              }
            }
          }
        })
        .state('files', {
          parent : 'fileBase',
          url : '/files?tla&year&category',
          data : {
            auth : {
              privilege : 'retailerManageReports'
            },
            requireTerms:true,
            path:'files',
            title:'Uploaded Files'
          },
          resolve : {
            reportsCount: function(Reports, $stateParams){
              return Reports.reportCount($stateParams.tla, $stateParams.category, $stateParams.year, $stateParams.itemsPerPage, $stateParams.pageNumber);
            },
            reports : function (Reports, $stateParams) {
              return Reports.find($stateParams.tla, $stateParams.category, $stateParams.year, $stateParams.itemsPerPage, $stateParams.pageNumber);
            },
            tlaTree : function(Reports, $stateParams) {
              if($stateParams.tla){
                return Reports.tlaFilterReport($stateParams);
              }
            }
          },
          views : {
            '@pageWithMenu' : {
              templateUrl : 'Files/Files.tmpl.html',
              controller : 'FilesCtrl as vm'
            },
            'fileTree@pageWithMenu' : {
              templateUrl: 'Files/FileTree.tmpl.html',
              controller: 'FileTreeCtrl as vm'
            }
          }
        })
  }

})();